
import Vue, { defineComponent } from 'vue'
export default defineComponent({
    name: "Home"
})
